import * as _ from 'lodash';

export class AptFileUploadSummaryCtrl {
  static bindings = {
    attachments: '<',
    onDelete: '&',
    allowDelete: '<',
    showDownloadUrl: '<',
    showFileSize: '<',
    onClickDelete: '<'
  };

  attachments;

  showIcon(attachment) {
    // These need to include tests for the MIME types as well. Some of the code may just do a direct assignment of
    // the type value from the File object and use that.
    return {
      'apt-file-excel-icon': attachment.fileType === 'xlsx',
      'apt-file-csv-icon': attachment.fileType === 'csv',
      'apt-file-word-icon': attachment.fileType === 'docx',
      'apt-file-pdf-icon':
        attachment.fileType === 'pdf' ||
        attachment.fileType === 'application/pdf',
      'apt-file-exclamation-icon':
        attachment.fileType !== 'xlsx' &&
        attachment.fileType !== 'docx' &&
        attachment.fileType !== 'pdf' &&
        attachment.fileType !== 'csv'
    };
  }
}

export const AptFileUploadSummaryComponent = {
  template: require('./aptFileUploadSummary.component.html'),
  controller: AptFileUploadSummaryCtrl,
  bindings: AptFileUploadSummaryCtrl.bindings
};
